import React from 'react'
import { Input } from 'reactstrap'

const TagsInput = (props) => {
  const { tags, value, onChange } = props
  const renderTagsBelow = props.renderTagsBelow !== false

  const removeTags = (indexToRemove) => {
    props.selectedTags([...tags.filter((_, index) => index !== indexToRemove)])
  }

  const addTag = (inputValue, target) => {
    const normalizedValue = inputValue.trim()
    if (normalizedValue === '') {
      return
    }

    if (props.validator) {
      if (props.validator(normalizedValue)) {
        props.selectedTags([...tags, normalizedValue])
        target.value = ''
      }
    } else {
      props.selectedTags([...tags, normalizedValue])
      target.value = ''
    }
  }

  const addTags = (event) => {
    event.preventDefault()
    addTag(event.target.value, event.target)
  }

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter') {
      return
    }

    event.preventDefault()
    addTag(event.currentTarget.value, event.currentTarget)
  }

  const tagsList = (
    <ul id="tags" className={renderTagsBelow ? 'tags-list-below' : ''}>
      {!!tags?.length &&
        tags.map((tag, index) => (
          <li key={index} className="tag">
            <span className="tag-title">{tag}</span>
            <span className="tag-close-icon" onClick={() => removeTags(index)}>
              x
            </span>
          </li>
        ))}
    </ul>
  )

  return (
    <div className={`tags-input ${renderTagsBelow ? 'tags-input-below' : ''}`}>
      {!renderTagsBelow && tagsList}
      <Input
        className="form-control-alternative"
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={props.placeholder}
        required={tags.length ? false : true}
        onBlur={(event) => addTags(event)}
      />
      {renderTagsBelow && tagsList}
    </div>
  )
}
export default TagsInput
